import './rosterLinks.css';

import CsvDownloader from 'react-csv-downloader';
import getCurrentDateTime from '../utils/getCurrentDateTime';
import { roster_columns } from '../utils/columns';
import { useCallback } from 'react';
import { getRoster } from '../../api/searchApi';
import sanitizeCsv from '../utils/sanitizeCsv';

const diseases = [
    { id: 'NMDA', displayText: 'Complete Adult NMD Working Group Roster' },
    { id: 'NMDP', displayText: 'Complete Pediatric NMD Working Group Roster' },
    { id: 'NMDMG', displayText: 'Complete Myasthenia Gravis Working Group Roster' },
    { id: 'NMDSMA', displayText: 'Complete Spinal Muscular Atrophy Working Group Roster' },
    { id: 'NMDDMD', displayText: 'Complete Duchenne and Becker Muscular Dystrophy Working Group Roster' },
    { id: 'NMD', displayText: 'Complete NMD Oversight Committee Roster' },
];

export default function RosterLinks() {
    const fetchRoster = useCallback(id => {
        const doFetch = async () => {
            const roster = await getRoster(id);

            return sanitizeCsv(roster.flatMap(r => r.rosterItems));
        };

        return doFetch();
    }, []);

    return (
        <ul className="roster-links">
            {diseases.map(d => {
                return (
                    <li key={d.id}>
                        <CsvDownloader
                            style={{ marginTop: '20px' }}
                            className="link-button"
                            text={d.displayText}
                            filename={`${d.id}-roster_${getCurrentDateTime()}`}
                            datas={() => fetchRoster(d.id)}
                            columns={roster_columns}
                            wrapColumnChar={'"'}
                        />
                    </li>
                );
            })}
        </ul>
    );
}